<template>
  <div class="grupo-familiar" v-loading="loading">
    <el-row :gutter="15">
      <el-col :span="12">
        <el-button
          style="width:100%; white-space:normal; background: none; border:none; padding: 0"
          @click="select(pacienteFiltrado)"
        >
          <div class="col click-button" style="display: flex; justify-content: center;">
            <div
              class="circle"
              :style="{background: pacienteFiltrado.cor, padding: 0, height: '75px', width: '75px', borderRadius: '40px'}"
            >
              <div class="abreviatura">
                {{ pacienteFiltrado.abreviacao }}
              </div>
            </div>
          </div>
          <div class="text-center">
            <div class="nome">
              {{ pacienteFiltrado.nome }}
            </div>
          </div>
        </el-button>
      </el-col>
      <el-col :span="12">
        <el-button
          style="width:100%; white-space:normal; background: none; border:none; padding: 0"
          @click="selecionaOutraPessoa"
        >
          <div class="col click-button text-center">
            <inline-svg style="height: 75px;" :src="require('@/assets/img/img_pessoas_celular.svg')"></inline-svg>
          </div>
          <div class="text-center">
            <div class="nome">
              Outra Pessoa
            </div>
            <div class="descritivo">
              Indique um familiar responsável
            </div>
          </div>
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { mapListaByContrato } from '@/components/GrupoFamiliar/GrupoFamiliarHelpers'
import InlineSvg from 'vue-inline-svg'

export default {
  name: 'GrupoFamiliarBeneficiario',
  components: { InlineSvg },
  props: {
    idFuncionalidade: {
      type: [Number, String]
    },
    value: {
      type: Object,
      default: () => ({})
    },
    numeroContrato: {
      type: String
    }
  },
  watch: {
    value (newValue) {
      this.beneficiarioSelecionado = newValue
    }
  },
  data () {
    return {
      listaContratoBeneficia: [],
      beneficiarioSelecionado: null,
      pacienteFiltrado: null,
      loading: true
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo', 'aplicacao', 'textoVinculoContrato']),
    ...mapGetters('Login', ['contratos', 'beneficiarios']),
    ...mapState('Func53', ['paciente']),
    ...mapState('SetupApp', ['apiGrupoFamiliar']),
    visualizaContratosVazios () {
      if (!this.aplicacao.grupoFamiliar) {
        return true
      }
      return this.aplicacao.grupoFamiliar.visualizaContratosVazios
    }
  },
  methods: {
    async init () {
      // Sempre que iniciado o Grupo Familiar deve iniciar com nenhum deles selecionados
      this.beneficiarioSelecionado = null

      let beneficiariosIntegracao = null
      try {
        beneficiariosIntegracao = await this.getGrupoFamiliar()
      } catch (ignored) {}
      this.loading = false

      this.listaContratoBeneficia = mapListaByContrato(
        beneficiariosIntegracao,
        this.contratos,
        this.beneficiarios,
        this.idFuncionalidade,
        this.visualizaContratosVazios
      )
      if (this.numeroContrato) {
        const filtrado = this.listaContratoBeneficia.filter((el, i) => {
          return el.contrato === this.numeroContrato
        })
        this.listaContratoBeneficia = filtrado
      }

      if (this.paciente) {
        this.pacienteFiltrado = this.listaContratoBeneficia[0].data.find(el => el.chaveUnica === this.paciente.chaveUnica)
      }
    },
    async getGrupoFamiliar () {
      if (this.apiGrupoFamiliar.grupoFamiliar) {
        const result = await this.apiGrupoFamiliar.grupoFamiliar({
          payload: {
            idFuncionalidade: this.idFuncionalidade
          },
          handlerErrorIgnore: true
        })

        if (!result.status) {
          return false
        }
        const { contratos } = result.data

        const invalid = contratos.filter(contrato => {
          return !contrato.beneficiarios
        })

        if (invalid.length) {
          return false
        }
        return contratos
      }
      return false
    },
    select (beneficiario) {
      // Propaga a mudança no valor
      this.$emit('input', beneficiario)
      this.$emit('click', beneficiario)
      this.beneficiarioSelecionado = beneficiario
    },
    selecionaOutraPessoa: function () {
      this.$router.replace({ query: { step: '3.2', contrato: this.pacienteFiltrado.numeroContrato, breadCrumbItem: this.pacienteFiltrado.nome } })
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style>
.container {
  width: 100%;
  justify-content: space-between;
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
}

.col1 {
  width: 80%;
  align-items: flex-start;
}

.col2 {
  padding-left: 13px;
}

.row {
  margin-top: 2px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.circle {
  display: flex;
  justify-content: center;
  align-items: center;
}

.nome {
  text-transform: none;
  font: normal normal 600 14px/19px Open Sans;
  letter-spacing: 0;
  color: #333333;
}

.texto {
  font: normal normal normal 12px/17px Open Sans;
  letter-spacing: 0;
  color: #555555;
}

.tipoBeneficiario {
  font: normal normal normal 12px/17px Open Sans;
  letter-spacing: 0;
  color: #555555;
  margin-left: 5px;
  text-transform: capitalize;
}

.abreviatura {
  font-size: 17px;
  font-family: "Open Sans";
  color: #FFFFFF;
}
.descritivo {
  font: normal normal normal 12px/17px Open Sans;
  color: #333333;
  text-transform: none;
}
.click-button {
  background: #006FB914;
  border: 1px solid #006FB929;
  padding:20px;
  border-radius: 4px;
  margin-bottom: 10px;
}
</style>
